import { QuestionStayableDayOfTheWeek } from "@/components/features/items/edit/_shared/ui/components/main/questions/stayable-day-of-the-week/stayable-day-of-the-week";

import { useDayTripPlanStayableDayOfTheWeek } from "./hooks";

export const QuestionDayTripPlanStayableDayOfTheWeek = () => {
	const {
		stayableDayOfTheWeek,
		rawStayableDayOfTheWeek,
		onSetStayableDayOfTheWeek,
		stayableDayOfTheWeekOptions,
		isHolidayStayable,
		onSetIsHolidayStayable,
	} = useDayTripPlanStayableDayOfTheWeek();

	return (
		<QuestionStayableDayOfTheWeek
			stayableDayOfTheWeekOptions={stayableDayOfTheWeekOptions}
			stayableDayOfTheWeek={stayableDayOfTheWeek}
			rawStayableDayOfTheWeek={rawStayableDayOfTheWeek}
			onSetStayableDayOfTheWeek={onSetStayableDayOfTheWeek}
			isHolidayStayable={isHolidayStayable}
			onSetIsHolidayStayable={onSetIsHolidayStayable}
		/>
	);
};

QuestionDayTripPlanStayableDayOfTheWeek.displayName = "QuestionDayTripPlanStayableDayOfTheWeek";
